import { FootnoteReferenceV2 } from '@oneaudi/feature-app-utils';
import { Footnote } from '@oneaudi/footnote-service/dist/cjs/types/footnotes-response.type';
import { useAppServices } from '~/app/contexts/app-context';

export default function PriceFootnote({ text }: { text: unknown }) {
	const {
		featureServices: { footnoteService },
	} = useAppServices();

	if (text) {
		const footnoteKey = `price-footnote`;
		const footnote = [{ Key: footnoteKey, Text: text?.toString() ?? '' } as Footnote];
		const alreadyExistingFootnotes = footnoteService?.getData();

		const footnoteFound = alreadyExistingFootnotes?.find((d) => d.Key === footnoteKey);
		if (footnoteFound) {
			footnoteService?.replaceFootNotes(footnote);
		} else {
			footnoteService?.addFootNotes(footnote);
		}
	}

	return <FootnoteReferenceV2 footnoteId="price-footnote" />;
}
